/**
 * The protected data a new account starts with, for every sign-up path (email wizard and the
 * Google, Facebook and LinkedIn confirm form). Only the fields listed here are kept. Age is an
 * "I'm 18 or older" confirmation: only the moment it was given is kept, never a date of birth
 * (Privacy B.1, 28 Oct 2026).
 */
// FieldCheckbox is a multi-checkbox: its value is the array of ticked values
export const isAgeConfirmed = value => Array.isArray(value) && value.length > 0;

export const signupProtectedData = (
  { email, ageConfirmed, phoneNumber, recentlyViewedListingIds },
  now = new Date()
) => ({
  email,
  ...(ageConfirmed && { ageConfirmedAt: now.toISOString() }),
  ...(phoneNumber && { phoneNumber }),
  ...(recentlyViewedListingIds !== undefined && { recentlyViewedListingIds }),
});
